import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Select from 'component/utils/Select'
import BranchSelectSimple from 'component/branch/BranchSelectSimple'

class AccomplishedCoachesView extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    count: PropTypes.number,
    user: PropTypes.object,
    title: PropTypes.string.isRequired,
    countSalesCoaching: PropTypes.func.isRequired,
  }

  state = {
    branchFilter: 0,
    branchArray: [],
    periodFilter: 0,
  }

  handleChange = (event, companyOptions) => {
    const { target } = event

    const { countSalesCoaching } = this.props

    let { periodFilter } = this.state
    let { branchFilter } = this.state

    if (target.name === 'store') {
      this.setState({ branchFilter: target.value })
      branchFilter = target.value
    } else {
      this.setState({ periodFilter: target.value })
      periodFilter = target.value
    }

    let dtStart = null
    let dtEnd = null

    if (parseInt(periodFilter, 10) !== 0) {
      dtStart = moment().subtract(periodFilter, 'd').format('DD/MM/YYYY')
      dtEnd = moment().format('DD/MM/YYYY')
    }

    let branchArray = []

    // Se for menor do que 3 caracteres sabemos que foi selecionada região
    if (branchFilter.length < 3 && companyOptions) {
      branchArray = companyOptions
        .filter(
          (branch) => parseInt(branch.idRegion, 10) === parseInt(branchFilter, 10)
        )
        .map((branch) => branch.value)
    } else if (branchFilter.length >= 3) {
      branchArray.push(branchFilter)
    } else {
      branchArray = this.state.branchArray
    }

    this.setState({ branchArray })

    countSalesCoaching({
      idBranches: branchArray,
      dtStart,
      dtEnd,
    })
  }

  render() {
    const { translate, count, user, title } = this.props

    const { periodFilter, branchFilter } = this.state

    const periods = [
      { key: 6, label: translate('salesCoaching.lastWeek') },
      { key: 29, label: translate('salesCoaching.lastMonth') },
      { key: 364, label: translate('salesCoaching.lastYear') },
      { key: 0, label: translate('salesCoaching.sinceAlways') },
    ]

    return (
      <div className='padding'>
        <Row className='align-center'>
          <h4 className='color-default-dark strong'>{title}</h4>
        </Row>

        <Row className='align-center'>
          <Col xs={12}>
            <h2 className='color-primary strong'>{count}</h2>
          </Col>
        </Row>

        <Row className='filters'>
          <Col xs={6}>
            <Select
              name='period'
              id='period'
              onChange={this.handleChange}
              value={periodFilter}
            >
              {periods.map((period) => (
                <option value={period.key} key={period.key}>
                  {period.label}
                </option>
              ))}
            </Select>
          </Col>

          <Col xs={6}>
            <BranchSelectSimple
              name='store'
              id='period'
              user={user}
              translate={translate}
              onChange={this.handleChange}
              noValueLabel={translate('salesCoaching.allBranches')}
              value={branchFilter}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccomplishedCoachesView
